import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EnterpriseNavigationService {
    private containerWindow: Window | null = null;
    private containerOrigin = '';
    private pendingNavigation: { referralId: string; direction: string } | null = null;

    setEnterpriseContainerWindow(win: Window | null, origin: string): void {
        this.containerWindow = win;
        this.containerOrigin = origin;
        if (win && origin && this.pendingNavigation) {
            const nav = this.pendingNavigation;
            this.pendingNavigation = null;
            win.postMessage({ type: 'NAVIGATE_REFERRAL', referralId: nav.referralId, direction: nav.direction }, origin);
        } else if (!win) {
            this.pendingNavigation = null;
        }
    }

    navigateToReferral(referralId: string, direction: string): void {
        if (this.containerWindow && this.containerOrigin) {
            this.containerWindow.postMessage(
                { type: 'NAVIGATE_REFERRAL', referralId, direction },
                this.containerOrigin
            );
        } else {
            this.pendingNavigation = { referralId, direction };
        }
    }
}
